// extracted by mini-css-extract-plugin
export var container = "PostHeader-module--container--958bf";
export var credits = "PostHeader-module--credits--a3185";
export var creditsLabel = "PostHeader-module--credits-label--97bc6";
export var hasDefault = "PostHeader-module--has-default--c61a8";
export var hasLongTitle = "PostHeader-module--has-long-title--73b5d";
export var hasMedia = "PostHeader-module--has-media--cbfff";
export var hasPortrait = "PostHeader-module--has-portrait--65a6a";
export var intro = "PostHeader-module--intro--f28ac";
export var isLong = "PostHeader-module--is-long--c9e74";
export var media = "PostHeader-module--media--0afdc";
export var title = "PostHeader-module--title--21f7f";
export var titleContainer = "PostHeader-module--title-container--67ff5";
export var wrapper = "PostHeader-module--wrapper--98a34";